import { SelfRegisterFlow } from "../basvuru/shared";

// SYSTEM 1 (ADR 0005 §3.1) — the STANDALONE self-serve "Kayıt ol" route (/kayit),
// reached from the homepage next to "Giriş yap". No quote form: a cold visitor
// creates an account with name/phone/email/password, verified by a phone OTP to
// the SUPPLIED number. All the UX (2 screens, ProblemJson surfacing, the three
// confirm outcomes) lives in <SelfRegisterFlow> so it reuses the funnel's design
// system and never forks a divergent look.
export function KayitPage() {
  return <SelfRegisterFlow />;
}
